module.exports = __webpack_public_path__ + "img/ch09_04_洛洛惊叹.f172bb18.jpg";